import { selectLocalPeer, useHMSStore } from "@100mslive/react-sdk";
import { convertHMSPeerToPeer } from "./helpers";

export const useHMSLocalParticipant = () => {
  const localPeer = useHMSStore(selectLocalPeer);
  return localPeer ? convertHMSPeerToPeer(localPeer) : undefined;
};
